import { render } from "./FileExports.vue?vue&type=template&id=33d930dc&scoped=true"
import script from "./FileExports.vue?vue&type=script&lang=js"
export * from "./FileExports.vue?vue&type=script&lang=js"

import "./FileExports.vue?vue&type=style&index=0&id=33d930dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d930dc"]])

export default __exports__